export const AUDIT_LOG_STATUS = {
  PENDING: 'Pending',
  SUCCESS: 'Success',
  FAILED: 'Failed',
} as const;

export const SCAN_AUDIT_LOG_PER_PAGE = 10;
